import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { TemplateStatus } from '../individual-group-files-list-items/individual-group-files-list-items.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'checklist-floater-action',
  templateUrl: './checklist-floater-action.component.html',
  styleUrls: ['./checklist-floater-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChecklistFloaterActionComponent {
  @Input() selectedItemsArray;
  @Input() isSharedFiles = false;
  @Output() onMoveClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDuplicateTemplate: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotInUseClicked: EventEmitter<any> = new EventEmitter<any>();
  @Input() isFromMXFinancialAccount = false;
  templateStatuses = [
    {
      type: 'Not Started',
      status: TemplateStatus.notStarted,
    },
    {
      type: 'Working on it',
      status: TemplateStatus.workingOnIt,
    },
    {
      type: 'Review',
      status: TemplateStatus.review,
    },
    {
      type: 'Needs Attention',
      status: TemplateStatus.needsAttention,
    },
    {
      type: 'Complete',
      status: TemplateStatus.complete,
    },
  ];

  private readonly templateStatusMenuClassMap: Record<string, string> = {
    [TemplateStatus.notStarted]: 'status-menu-item status-menu-item-notStarted',
    [TemplateStatus.workingOnIt]: 'status-menu-item status-menu-item-workingOnIt',
    [TemplateStatus.review]: 'status-menu-item status-menu-item-review',
    [TemplateStatus.needsAttention]: 'status-menu-item status-menu-item-needsAttention',
    [TemplateStatus.complete]: 'status-menu-item status-menu-item-complete',
  };

  get isDownloadableFilesOnly() {
    return this.selectedItemsArray.every((item) => item?.fid == 1);
  }

  clearSelection() {
    this.onMoveClicked.emit('clearSelection');
  }
  deleteChecklist() {
    this.onMoveClicked.emit('deleteChecklist');
  }
  move() {
    this.onMoveClicked.emit('move');
  }
  notInUse() {
    this.onNotInUseClicked.emit('notInUse');
  }
  unShareFile() {
    this.onMoveClicked.emit('unShareFile');
  }
  downloadChecklist() {
    this.onMoveClicked.emit('download');
  }
  duplicateTemplate() {
    this.onDuplicateTemplate.emit('duplicate');
  }
  shareChecklist() {
    this.onMoveClicked.emit('share');
  }
  handleStatusChange(status) {
    this.onMoveClicked.emit({ type: 'templateStatus', value: status.status });
  }
  getStatusMenuItemClass(status: TemplateStatus | string): string {
    return this.templateStatusMenuClassMap[status] ?? '';
  }
  handleStatusMenu(event) {
    event.stopPropagation();
    event.preventDefault();
    const target = event.target as HTMLElement;
    const classEl = document.querySelectorAll('.statusMenu');
    if (target) {
      const computedStyle = window.getComputedStyle(target);
      const { width } = computedStyle;
      classEl.forEach((element: HTMLElement) => {
        element.style.minWidth = width;
        element.style.width = width;
      });

      const statusWrapper = document.querySelector('.mat-mdc-menu-content');
      if (statusWrapper) {
        (statusWrapper as any).style.padding = '0';
      }
      const statusItem = document.querySelectorAll('.mat-mdc-menu-item-text');
      statusItem.forEach((element: HTMLElement) => {
        element.style.fontSize = '12px';
        element.style.fontWeight = '600';
      });
    }
  }
}
